import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IAppConfig } from '../interface/app-config';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  constructor(private http: HttpClient) {}
  load() {
    const appConfFile = `assets/config.json`;
    return new Promise<void>((resolve, reject) => {
      // App Config
      lastValueFrom(this.http.get<IAppConfig>(appConfFile))
        .then((response) => {
          AppConfig.settings = response;
          resolve();
        })
        .catch((response) => {
          reject(
            `Could not load file '${appConfFile}': ${JSON.stringify(response)}`
          );
        });
    });
  }
}
